import { eventsTable } from '@/controllers/events-table'
import { pineapple } from '@/controllers/events'

const [route, action] = ['pineapple', 'update-check-address-messages']

export const updatePineappleCheckAddressMessages = function (data, callback) {
  window[Symbol.for('vue.prototype')].$sendMessageToWorker({ route, action, data })

  eventsTable[pineapple[action]] = callback
}
